<template>
  <component :is="props.is" v-bind="props">
    <slot />
    <v-alert v-show="props.errorMessage" type="error" class="ma-4">
      <slot name="error">
        {{ props.errorMessage }}
      </slot>
    </v-alert>
  </component>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

type ErrorMessageWrapperProps = {
  errorMessage: string | boolean | null
  is?: string | Component
}

const props = withDefaults(defineProps<ErrorMessageWrapperProps>(), {
  is: 'div',
})
</script>
